export default "__VITE_ASSET__CkaaA_Ge__"